<style src="./EventDetailsHeader.scss" lang="scss" scoped></style>
<template>
  <section class="form-box event-details-header row">
    <div class="col-4">
      <div class="row">
        <div class="field">
          <span class="title">Cliente</span>
          <span class="value">{{ eventInfo.client.shortName }}</span>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="field">
            <span class="title">Identificação</span>
            <span class="value">{{ eventInfo.identification || '-' }}</span>
          </div>
        </div>
        <div class="col-6">
          <div class="field">
            <span class="title">Código</span>
            <span class="value">{{ eventInfo.alternativeCode || '-' }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="col-4">
      <div class="row">
        <div class="field">
          <span class="title">Modalidade</span>
          <span class="value">{{ eventInfo.modality || '-' }}</span>
        </div>
      </div>

      <div class="row">
        <div class="field">
          <span class="title">Objeto</span>
          <span class="value">{{ eventInfo.eventObject || '-' }}</span>
        </div>
      </div>
    </div>

    <div class="col-4">
      <div class="row">
        <div class="field">
          <span class="title">Data de Entrega</span>
          <span class="value">{{ eventInfo.date.deadline | FriendlyDateTime }}</span>
        </div>
      </div>

      <div class="row">
        <div class="field">
          <span class="title">Data do Evento</span>
          <span class="value">{{ eventInfo.date.event | FriendlyDateTime }}</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import moment from 'moment'

export default {
  name: 'EventDetailsHeader',
  props: {
    eventId: ''
  },
  data () {
    return {
      eventInfo: {
        alternativeCode: '',
        identification: '',
        modality: '',
        client: {
          _id: null,
          shortName: ''
        },
        countItems: null,
        estimated: 0,
        eventObject: null,
        date: {
          event: '',
          deadline: ''
        },
        sourcePortal: ''
      }
    }
  },
  filters: {
    FriendlyDateTime (vl) {
      if (!vl) {
        return '-'
      }

      const date = moment(vl).format('DD/MM/YYYY')
      const time = moment(vl).format('HH:mm')

      return `${date} - ${time}`
    }
  },
  mounted () {
    this.GetEventdetails()
  },
  methods: {
    async GetEventdetails () {
      const eventInfo = await this.$store.dispatch('Board/GET_EVENT_DETAILS', {
        eventId: this.eventId
      })
      this.eventInfo = eventInfo
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/foundation/event-details-header/EventDetailsHeader.vue